import http from '../http';
import { API_BASE_URL } from '../../config';

export default class VehicleService {
  static getOwnerVehicles = (ownerId) =>
    http
      .get(`${API_BASE_URL}/v2/owners/${ownerId}/vehicles`)
      .then((res) => res.data);
  static getVehicleById = (vehicleId) =>
    http.get(`${API_BASE_URL}/v2/vehicles/${vehicleId}`).then((res) => res.data);

  static addVehicles = (payload) =>
    http.post(`${API_BASE_URL}/v2/vehicles`, payload);

  static updateVehicles = (vehicleId, payload) =>
    http.put(`${API_BASE_URL}/v2/vehicles/${vehicleId}`, payload);

  static updateVehicleDocument = (vehicleId, payload) =>
    http.put(`${API_BASE_URL}/v2/vehicles/document/${vehicleId}`, payload);

  static verifyVehicle = (vehicleId, payload) => {
    return http.put(`${API_BASE_URL}/v2/vehicles/${vehicleId}/verify`, payload);
  }

  static deleteVehicleByOwner = (ownerId, vehicleId) => {
    return http.put(`${API_BASE_URL}/v2/owners/${ownerId}/vehicles/${vehicleId}/delete`);
  }
}
